var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "course-obj section-holder"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "text-center card-icon"
  }, [_vm._v("?")]), _vm._v(" "), _c('h6', {
    staticClass: "pb-2"
  }, [_vm._v("Why should I take up this course?")]), _vm._v(" "), _c('p', [_vm._v("By the end of the course, you will be able to \r\n                        sketchuser interfaces, user flows, ui animations\r\n                        and storyboards.\r\n                     ")]), _vm._v(" "), _c('p', [_vm._v("By the end of the course, you will be able to \r\n                        sketchuser interfaces, user flows, ui animations\r\n                        and storyboards.\r\n                     ")]), _vm._v(" "), _c('p', [_vm._v("By the end of the course, you will be able to \r\n                        sketchuser interfaces, user flows, ui animations\r\n                        and storyboards.\r\n                     ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "text-center card-icon"
  }, [_vm._v(":O")]), _vm._v(" "), _c('h6', {
    staticClass: "pb-2"
  }, [_vm._v("What will I learn?")]), _vm._v(" "), _c('p', [_vm._v("By the end of the course, you will be able to \r\n                        sketchuser interfaces, user flows, ui animations\r\n                        and storyboards.\r\n                     ")]), _vm._v(" "), _c('p', [_vm._v("By the end of the course, you will be able to \r\n                        sketchuser interfaces, user flows, ui animations\r\n                        and storyboards.\r\n                     ")]), _vm._v(" "), _c('p', [_vm._v("By the end of the course, you will be able to \r\n                        sketchuser interfaces, user flows, ui animations\r\n                        and storyboards.\r\n                     ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "text-center card-icon"
  }, [_vm._v("!")]), _vm._v(" "), _c('h6', {
    staticClass: "pb-2"
  }, [_vm._v("How will this course benefit me?")]), _vm._v(" "), _c('p', [_vm._v("By the end of the course, you will be able to \r\n                        sketchuser interfaces, user flows, ui animations\r\n                        and storyboards.\r\n                     ")]), _vm._v(" "), _c('p', [_vm._v("By the end of the course, you will be able to \r\n                        sketchuser interfaces, user flows, ui animations\r\n                        and storyboards.\r\n                     ")]), _vm._v(" "), _c('p', [_vm._v("By the end of the course, you will be able to \r\n                        sketchuser interfaces, user flows, ui animations\r\n                        and storyboards.\r\n                     ")])])])])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ed193b88","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/course/courseObjectives.vue
// module id = xRXm
// module chunks = 1